module.exports = __webpack_public_path__ + "img/image_6.746569d1.png";